<template>
    <div>
      <el-card class="box-card" style="margin: 30px;">
        <el-tabs v-model="activeName" style="margin-left: 40px; margin-right: 40px;">
          <el-tab-pane label="产品属性(价格无关)" name="gattr">
            <GAttrs @getattrs="getattrs"></GAttrs>
          </el-tab-pane>
          <el-tab-pane label="产品规格(价格相关)" name="gspec">
            <GSpecs></GSpecs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>
</template>

<script>
  import GAttrs from './GAttrs'
  import GSpecs from './GSpecs'
  export default {
    name: 'GoodsAttrSpec',
    components: {GSpecs, GAttrs},
    data () {
      return {
        activeName: 'gattr'
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/newgoods/GoodsAttrSpec.vue